import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AppSnackbarProvider } from "./components/AppSnackbarProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppSnackbarProvider>
      <App />
    </AppSnackbarProvider>
  </React.StrictMode>
);
